





















import Vue from "vue";
export default Vue.extend({
  name: "MessageModal",
  props: {
    important:
    {
      type: String,
      default: ""
    } ,
    header: {
      type: String,
      default: "Information"
    },
    "button-text": {
      type: String,
      default: "OK"
    }
  },
  methods: {
    close: function(): void {
      this.$emit("close");
    }
  }
});
